import { CURRENCY_CONFIG } from "@/lib/currency";

/**
 * Format price with currency symbol and per-currency decimal places
 * @param price - Price amount
 * @param currency - Currency code (default: "TRY")
 * @returns Formatted price string
 */
export const formatPrice = (price: number, currency: string = "TRY"): string => {
  const config = CURRENCY_CONFIG[currency];
  const symbol = config?.symbol ?? currency;
  const decimals = config?.decimals ?? 2;

  if (isNaN(price)) {
    return `${symbol}${(0).toFixed(decimals)}`;
  }

  return `${symbol}${price.toFixed(decimals)}`;
};

/**
 * Format credit amount (no currency symbol — Harmony Credits)
 * @param amount - Credit amount
 * @returns Formatted credit string
 */
export const formatCredit = (amount: number): string => {
  if (isNaN(amount)) return "0 💠";
  return (amount % 1 === 0 ? String(amount) : amount.toFixed(2)) + ' 💠';
};
